import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { isExternalLink } from "@/lib/external-link";

const headingLine = (node: unknown): number | null => {
  if (typeof node !== "object" || node === null) {
    return null;
  }

  const { position } = node as { position?: { start?: { line?: number } } };

  return typeof position?.start?.line === "number" ? position.start.line : null;
};

export const MarkdownContent = ({
  content,
  headingIds,
}: {
  readonly content: string;
  readonly headingIds?: Record<number, string>;
}) => {
  return (
    <ReactMarkdown
      components={{
        a: ({ href, children }) => {
          const external = isExternalLink(href ?? "");

          return (
            <a href={href} rel={external ? "nofollow" : undefined}>
              {children}
            </a>
          );
        },
        h2: ({ children, node }) => {
          const line = headingLine(node);
          const id = line === null ? undefined : headingIds?.[line];

          return (
            <h2 className={id ? "scroll-mt-28" : undefined} id={id}>
              {children}
            </h2>
          );
        },
        table: ({ children }) => (
          <div className="max-w-full overflow-x-auto">
            <table>{children}</table>
          </div>
        ),
      }}
      remarkPlugins={[remarkGfm]}
    >
      {content}
    </ReactMarkdown>
  );
};
